export default "__VITE_ASSET__BuaVHEwi__"